export default __webpack_public_path__ + "static/screenshot-feature-importances--mobile-f459a0c8dd7d65d3cb2c6f3965bb8c2a.webp";